import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ClampLines from 'react-clamp-lines';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';

import { getLegacySession } from '../../../bridge';
import { formatDate } from '../../../helpers/itpmetricsUtils';
import { __ } from '../../../helpers/translations';
import { getCookieValue, getLanguage } from '../../../helpers/utils';
import { ITPMETRICS_BLUE } from '../common/Colours';

import './DashboardCard.scss';

function ParticipantCard({ item }) {
  const onClick = async () => {
    if (item.team_designer_assessment && item.completed === 2) {
      Swal.fire({
        text: __('G191'),
        icon: 'info',
        confirmButtonColor: ITPMETRICS_BLUE,
        confirmButtonText: 'OK',
      });
      return;
    }
    const { response: { sessionId, url } } = await getLegacySession();
    const language = getLanguage();
    const queryParams = `guid=${item.participant_guid}&ltiSessionId=${sessionId}&language=${language}`;
    const newUrl = item.team_designer_assessment
      ? `${url}/take.team.designer.assessment?${queryParams}`
      : `${url}/take.assessment?${queryParams}`;
    if (isMobile) {
      window.location.href = newUrl;
    } else {
      window.open(newUrl);
    }
  };

  const row = getCookieValue('display-rows');

  return row ? (
    <Card
      onClick={onClick}
      className="dashboard-card-row p-2"
    >
      <Row>
        <Col sm={6} md={6} lg={6}>
          <ClampLines
            id={`participant-title-${item.guid}`}
            text={item.name}
            lines={1}
            buttons={false}
            className="dashboard-card-title"
          />
        </Col>
        <Col sm={2} md={2} lg={2}>
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.8em',
          }}
          >
            {item.questionnaire_name}
          </div>
        </Col>
        <Col sm={2} md={2} lg={2}>
          {item.completed ? (
            <div>{__('G83')}</div>
          ) : null}
        </Col>
        <Col sm={2} md={2} lg={2}>
          {item.date_scheduled_start && (
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.7em',
          }}
          >
            {formatDate(item.date_scheduled_start)}
          </div>
          )}
        </Col>
      </Row>
    </Card>
  ) : (
    <Card
      onClick={onClick}
      className="mx-2 my-3 dashboard-card"
    >
      <Card.Body>
        <>
          <ClampLines
            id={`participant-title-${item.guid}`}
            text={item.name}
            lines={3}
            buttons={false}
            className="dashboard-card-title"
          />
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.8em',
          }}
          >
            {item.questionnaire_name}
          </div>
          {!item.completed && (
          <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle" />
          )}
          {item.date_scheduled_start && (
          <div style={{
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.7em',
          }}
          >
            {formatDate(item.date_scheduled_start)}
          </div>
          )}
          {item.completed ? (
            <div style={{ bottom: '1em', position: 'absolute', fontSize: '13px' }}>{__('G83')}</div>
          ) : null}
        </>
      </Card.Body>
    </Card>
  );
}

ParticipantCard.propTypes = {
  item: PropTypes.object,
};

export default ParticipantCard;
